import { axiosGet, axiosPost, axiosDelete, axiosGetNoEncrypt, axiosPostNoEncrypt } from '@/http/api'

/**
 * @description 获取证件照列表
 */
export function getList() {
  return new Promise((resolve, reject) => {
    axiosGet(`/api/id-photo/mine/certificates`)
      .then((res) => {
        console.log('res', res)
        const list = res.data.map((item) => {
          return {
            id: item.id,
            coverImg: item.coverImg
          }
        })
        resolve(list)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * @description 获取证照详情
 */
export function getCertificateDetail(typeId) {
  const certificateKeys = ['', 'idcard', 'residence-booklet', 'driver-license', 'marriage-certificate', '', '']
  return new Promise((resolve, reject) => {
    axiosGetNoEncrypt(`/self-apps/api/id-photo/${certificateKeys[typeId]}`)
      .then((res) => {
        resolve(res?.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * @param {String} id 证件id
 * @description 添加证件照
 */
export function addItem(certId) {
  return new Promise((resolve, reject) => {
    axiosPost(`/api/id-photo/certificate`, { certId })
      .then(() => {
        resolve()
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * @param {String} id 证件id
 * @description 删除证件照
 */
export function deleteItem(id) {
  return new Promise((resolve, reject) => {
    axiosDelete(`/api/id-photo/mine/${id}/certificate`)
      .then(() => {
        resolve()
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * @description 获取可添加的证件照列表
 */
export function getAddList() {
  return new Promise((resolve, reject) => {
    axiosGet(`/api/id-photo/certificates`)
      .then((res) => {
        const list = res.data.map((item) => {
          return {
            id: item.id,
            title: item.title,
            state: item.isRelation
          }
        })
        resolve(list)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * @description 切换证件保护开关
 */
export function editAuthenticationSwitch(val) {
  return new Promise((resolve, reject) => {
    axiosPost('/api/id-photo/certificate/switch', { switchCert: val ? 1 : 0 })
      .then((res) => {
        resolve(res.data?.certSwitch)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * @description 获取证件保护开关
 */
export function getAuthenticationSwitch() {
  return new Promise((resolve, reject) => {
    axiosGet('/api/id-photo/certificate/switch')
      .then((res) => {
        if (res.data) {
          resolve(res.data?.certSwitch)
        } else {
          reject(res)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 证照模块oauth认证
export function licenseOauth(code, appId, clientId, redirectUrl) {
  return axiosPostNoEncrypt('/self-apps/api/login', { code, appId, clientId, redirectUrl })
}

// 刷新oauth认证
export function refreshOauth(clientId, refreshToken) {
  return axiosPostNoEncrypt('/self-apps/api/refresh', { clientId, refreshToken })
}
